import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import ListFromTable from 'components/common/ListFromTable'
import {
  licenseeApplicationFetchTableData,
  licenseeApplicationClearStateList,
  licenseeApplicationDelete,
} from 'reducers/licenseeApplication/reducer'
import * as ROUTE from 'constants/appRouting'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import UrlHelper from 'helpers/url'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import DateColumn from 'types/table/DateColumn'
import ActiveColumn from 'types/table/ActiveColumn'
import messages from './translate'

class LicenseeApplicationList extends ListFromTable {
  constructor(props) {
    super(props)
    this.getTableData = props.licenseeApplicationFetchTableData
    this.deleteEntity = props.licenseeApplicationDelete
    this.clearReducerState = props.licenseeApplicationClearStateList
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { licenseeId, tableData } = this.props

    if (nextProps.licenseeId !== licenseeId) {
      this.reloadTableData(ROUTE.LICENSEE_APPLICATION_LIST)

      return false
    }

    if (tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.licenseeApplicationList),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
    }
  }

  getCreateButton() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.createButton),
      link: ROUTE.LICENSEE_APPLICATION_CREATE,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()

    columns.add(new Column('id', 'ID', { sorting: true }))
    columns.add(
      new Column('application', formatMessage(messages.application), {
        sorting: true,
        render: rowData => rowData.appName,
      }),
    )
    columns.add(
      new Column('licensee', formatMessage(messages.licensees), {
        sorting: true,
        render: rowData => rowData.licenseeName,
      }),
    )
    columns.add(
      new ActiveColumn('enableInUi', formatMessage(messages.enableInUi), {
        sorting: true,
      }),
    )
    columns.add(
      new ActiveColumn(
        'showInSideBarMenu',
        formatMessage(messages.showInSideBarMenu),
        {
          sorting: true,
        },
      ),
    )
    columns.add(
      new Column('orderNumber', formatMessage(messages.orderNumber), {
        sorting: true,
        render: rowData => rowData.orderNumber,
      }),
    )
    columns.add(
      new DateColumn('dateUpdated', formatMessage(messages.dateUpdated), {
        sorting: true,
      }),
    )

    return columns
  }

  getActions() {
    const {
      intl: { formatMessage },
      history,
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action(
        'edit',
        formatMessage(messages.editLicenseeApplication),
        row => {
          history.push(
            UrlHelper.create(ROUTE.LICENSEE_APPLICATION_EDIT, { id: row.id }),
          )
        },
      ),
    )
    actions.add(
      new Action(
        'delete',
        formatMessage(messages.deleteLicenseeApplication),
        row => {
          this.onOpenConfirmDialog({ entityId: row.id, psfs: this.psfs })
        },
      ),
    )

    return actions
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.deleteLicenseeApplication),
      message: formatMessage(messages.deleteLicenseeApplicationMessage),
    }
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['licenseeApplication', 'tableData']),
    licenseeId: state.getIn(['profile', 'licenseeId']),
  }),
  {
    licenseeApplicationFetchTableData,
    licenseeApplicationClearStateList,
    licenseeApplicationDelete,
  },
)(injectIntl(LicenseeApplicationList))
